import { buildClarityWorkspaceUrl } from './build-clarity-workspace-url.util';
import {
	readClarityWorkspaceRoute,
	toClaritySectionUrl,
	toNavigationUnlessCurrent,
} from './clarity-workspace-route.util';
import type { ClarityWorkspaceNavigation } from './models/clarity-workspace-navigation.model';
import { parseClarityWorkspaceLocation } from './parse-clarity-workspace-location.util';

/** Ported from Clarity `apps/web/src/shared/hooks/useWorkspaceCanonicalization.ts` (commit `f9217bb5a`). */
/**
 * The correction that makes a workspace URL canonical, as a **replace** — brain's
 * `useWorkspaceCanonicalization`: an unknown or missing tab becomes `pulse`; invalid `doc` / `file` /
 * `oi` / `action` / `page` values, `page` without `doc` and `doc` beside `file` are dropped; the legacy
 * `domain` / `tab` keys are stripped; every other key is carried verbatim. `null` — no navigation — for a
 * canonical URL, so running it again cannot loop, and for a URL that is not a workspace URL.
 *
 * Two things differ, both on purpose. A malformed domain id answers `null`, because brain hands it to
 * its resolver, which is the generic workspace's and not ported. A path deeper than the tab
 * (`/<section>/d/<id>/<tab>/…`), which brain's route never matches, is folded into the canonical URL —
 * the System Domain branch catches such a URL and shows the console (Maksim, 2026-09-26).
 */
export function toClarityCanonicalNavigation(
	currentUrl: string,
	sectionPath: string,
): ClarityWorkspaceNavigation | null {
	const current = readClarityWorkspaceRoute(currentUrl, sectionPath);

	if (!current.isWorkspaceUrl) {
		return null;
	}

	const parsed = parseClarityWorkspaceLocation(current.params, current.search);

	if (parsed.domainId === null) {
		return null;
	}

	return toNavigationUnlessCurrent(
		current,
		toClaritySectionUrl(sectionPath, buildClarityWorkspaceUrl(parsed, current.search)),
		true,
	);
}
